import {OwnershipDocument} from "../models/OwnershipDocument";
import {PreviewOwnershipReproDocumentTemplateData} from "./PreviewOwnershipReproDocumentTemplateData";
import {PreviewOwnershipReproDocumentImportTemplate} from "./PreviewOwnershipReproDocumentImportTemplate";
import {cloneDeep} from "lodash";

export const getPreviewOwnershipReproDocumentTemplate = (
    documentsOfImport: OwnershipDocument[],
    selectedWarehouse: string,
    reproProductNames: string[],
    dateFrom: Date,
    dateTo: Date
    ) => {
    return PreviewOwnershipReproDocumentImportTemplate(prepareData(
        documentsOfImport.sort((a: OwnershipDocument, b: OwnershipDocument) => {
            return (new Date(a?.date as Date)).getTime() < (new Date(b?.date as Date)).getTime() ? 1 : -1}),
        selectedWarehouse,
        reproProductNames,
        dateFrom,
        dateTo
    ));
};

const prepareData = (
    documentsOfImport: OwnershipDocument[],
    selectedWarehouse: string,
    reproProductNames: string[],
    dateFrom: Date,
    dateTo: Date
    ) => {
    const templateData: PreviewOwnershipReproDocumentTemplateData = {
        documentsOfImport: cloneDeep(documentsOfImport),
        selectedWarehouse: selectedWarehouse ? ` u magacinu ${selectedWarehouse}` : ' za sve magacine',
        reproProductNames: reproProductNames,
        dateFrom: dateFrom,
        dateTo: dateTo
    };

    return templateData;
};